/** Runtime configuration. Mirrors the keys of the Angular `environment` files that are actually used. */
export const env = {
  /** Prefix of every API call. Relative in production (same-origin nginx); the Vite dev server proxies it. */
  apiVersionUrl: import.meta.env.VITE_API_VERSION_URL ?? '/api/v1/',
  /** Cognito issuer URL; the user pool id is its last path segment. */
  stsServerUrl: import.meta.env.VITE_STS_SERVER_URL ?? '',
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
  helpDeskUrl: import.meta.env.VITE_HELP_DESK_URL ?? '',
  applyPresenterUrl: import.meta.env.VITE_APPLY_PRESENTER_URL ?? '',
} as const;
